//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { GalleriesEmbedActionType } from '@galleries/actions/galleriesEmbedActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesEmbedModal } from '@galleries/models/galleriesStateModel';

const initialState: IGalleriesEmbedModal = {
  isModalOpen: false,
};

export default function GalleriesCustomizationReducer(
  state: IGalleriesEmbedModal = initialState,
  action: GalleriesEmbedActionType,
): IGalleriesEmbedModal {
  switch (action.type) {
    case GALLERIES_ACTIONS.OPEN_EMBED_GALLERY_MODAL: {
      return {
        ...state,
        isModalOpen: true,
      };
    }
    case GALLERIES_ACTIONS.CLOSE_EMBED_GALLERY_MODAL: {
      return {
        ...state,
        isModalOpen: false,
      };
    }
    default:
      return state;
  }
}
